import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false); // Close mobile menu on route change
    setIsProductsOpen(false);   // Close dropdown as well
  }, [location]);

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-[#193356] text-white px-4 py-3 shadow-md">
  <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
 <Link to="/" className="flex items-center">
  <Link to="/" className="flex items-center">
    <img
      src="/aarsh_logo.svg"
      alt="Aarsh Logo"
      className="h-12 w-auto"
      style={{
        border: "none",
        outline: "none",
        boxShadow: "none",
        background: "transparent"
      }}
    />
  </Link>
</Link>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-8 items-center">
          <li>
            <Link to="/" className="hover:text-[#54c5d9]">
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" className="hover:text-[#54c5d9]">
              About Us
            </Link>
          </li>

          {/* Products Dropdown */}
          <li className="relative group">
            <button className="hover:text-[#54c5d9] group-hover:text-[#54c5d9] px-4 py-3 h-12 flex items-center">
              Products ▾
            </button>
            <ul className="absolute hidden group-hover:block bg-[#324865] text-white shadow-lg mt-0 rounded-lg w-48 z-50">
              <li className="px-4 py-2 whitespace-nowrap">
                <Link to="/products/taps" className="block hover:text-[#54c5d9]">
                  Taps & Faucets
                </Link>
              </li>
              <li className="px-4 py-2 whitespace-nowrap">
                <Link to="/products/accessories" className="block hover:text-[#54c5d9]">
                  Accessories
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/contact" className="hover:text-[#54c5d9]">
              Contact
            </Link>
          </li>
        </ul>

        {/* Mobile Hamburger */}
        <div className="md:hidden">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Drawer (slides from right) */}
      {isMobileMenuOpen && (
        <div className="fixed top-0 right-0 w-64 bg-[#10295f]/90 backdrop-blur-sm shadow-lg z-50 transition-transform duration-300 ease-in-out pt-0 pb-2 max-h-screen">
          <div className="flex justify-end px-4 py-2">
            <button
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-white hover:text-[#54c5d9] transition duration-200"
            >
                <FaBars size={24} />
            </button>
            </div>
          <ul className="flex flex-col space-y-4 p-4">
            <li>
              <Link to="/" className="hover:text-[#54c5d9]">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-[#54c5d9]">
                About Us
              </Link>
            </li>
            <li>
              <button
                onClick={() => setIsProductsOpen(!isProductsOpen)}
                className="flex justify-between items-center w-full hover:text-[#54c5d9]"
              >
                <span>Products</span>
                <span>{isProductsOpen ? "▲" : "▼"}</span>
              </button>
              {isProductsOpen && (
                <ul className="ml-4 mt-2 space-y-2">
                  <li>
                    <Link to="/products/taps" className="block hover:text-[#54c5d9]">
                      Taps & Faucets
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/accessories" className="block hover:text-[#54c5d9]">
                      Accessories
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <Link to="/contact" className="hover:text-[#54c5d9]">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
